// Application-defined WebSocket close codes (RFC 6455 reserves 4000–4999).
//
// These mirror `remote-worker/src/close-codes.ts` deliberately: the worker's
// admission slice picked the convention (4400/4401/4408/4500 mapped to HTTP
// 400/401/408/500), and the end-to-end layer keeps the same numbering so a
// client doesn't need two close-code dictionaries.
//
// Reasons are short machine-readable strings — clients should branch on them,
// not parse prose. Keep stable: any rename is a public protocol change.

export const PEER_CLOSE = {
  BAD_REQUEST: { code: 4400, reason: 'bad-request' },
  AUTH_FAILED: { code: 4401, reason: 'auth-failed' },
  TIMEOUT: { code: 4408, reason: 'timeout' },
  INTERNAL: { code: 4500, reason: 'internal' },
} as const;

export type PeerCloseCode = (typeof PEER_CLOSE)[keyof typeof PEER_CLOSE];
